import React, { useMemo } from 'react'
import _ from 'lodash'
import utils from '../../utils'
import { Calendar } from 'primereact/calendar'

export default function LtsCalendar(props) {
  const onChange = (event) => {
    const target = event.target
    // com mascara, o Calendar avisa "sem data" a cada tecla enquanto a data esta incompleta. Repassar isso troca o
    // valor do campo e o Calendar reescreve o texto, apagando o que acabou de ser digitado. So vale como "sem data"
    // quando o campo ficou sem nenhum digito
    if (props.mask && !target.value && /\d/.test(_.get(event, 'originalEvent.target.value', ''))) {
      return
    }
    props.onChange(target.value)
  }

  const resolveName = () => {
    return props.name || 'data'
  }

  const resolveLabel = () => {
    if (props.label) {
      return <label>{props.label || 'Data'}</label>
    }
    return null
  }

  // a mesma data entre renderizacoes tem de ser o mesmo objeto: o Calendar reescreve o texto do campo sempre que
  // recebe um objeto novo, mesmo com a mesma data, e isso apagaria uma digitacao em andamento
  const chaveDoValor = utils.isDate(props.value) ? props.value.getTime() : props.value
  const value = useMemo(
    () => (props.showTime ? utils.getDateTimeFromNumber(props.value) : utils.getDateFromNumber(props.value)),
    [chaveDoValor, props.showTime] // eslint-disable-line react-hooks/exhaustive-deps
  )

  return (
    <React.Fragment>
      <span className="p-float-label">
        <Calendar
          {...props}
          className={props.className}
          value={value}
          onChange={onChange}
          yearRange={utils.getYearRangeFromDate('1800')}
          name={resolveName()}
          showButtonBar={true}
          view={props.view || 'date'}
          dateFormat={props.dateFormat}
          showTime={props.showTime}
        />
        {resolveLabel()}
      </span>
    </React.Fragment>
  )
}
